<template>
<div :class="{'ui-circle-preloader':true, '--secundary': themeColor }" :style="spinnerStyle"/>
</template>

<script>
import VueTypes from "vue-types";

export default {
    name: "MyCirclePreloader",
    props: {
        strokeWidth: VueTypes.number.def(2),
        size: VueTypes.number.def(24),
        themeColor: VueTypes.bool.def(false)
    },
    computed: {
        spinnerStyle() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                padding: `${this.strokeWidth}px`,
            };
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>